module.exports = __webpack_public_path__ + "img/service.9bfce2e2.jpeg";